<template>
  <article class="bg-white p-3 shadow-md rounded-md">
    <p class="font-bold py-2">
      {{ answer.question?.prompt }}
    </p>
    <div
      v-for="(item, index) in processedItems"
      :key="item"
      class="flex flex-row items-center gap-2"
    >
      <span class="font-bold">{{ getAnswerLabel(index) }}</span>
      <span v-html="item.answerText" class="item-answer"></span>
    </div>
    <div
      v-if="correctedItems.length === 0"
      class="border-2 border-h-success-200 p-4 flex flex-col gap-3 bg-h-neutral-100 mt-4 rounded">
      <div class="flex flex-row items-center gap-3">
        <v-icon
          name="hi-solid-check-circle"
          :scale="1.3"
          class="text-[#74B543]"
        />
        <span>{{
          $t("labels.generic", { pt: "Resposta certa", en: "Correct response" })
        }}</span>
        <v-icon name="hi-solid-check-circle" :scale="1.3" class="text-[#74B543]" />
        <span>{{$t('labels.generic', {pt:"Resposta certa", en:"Correct response"}) }}</span>
      </div>
    </div>
    <div v-for="item in correctedItems" :key="item.text">
      <div
        v-if="item.correctedItem.has"
        class="border-2 border-h-error-100 p-4 flex flex-col gap-3 bg-h-neutral-100 mt-4 rounded"
      >
        <div class="flex flex-row items-center gap-3">
          <v-icon name="hi-solid-x-circle" :scale="1.3" class="text-[#BB414A]" />
          <span>{{$t('labels.generic', {pt:"Resposta incorreta", en:"Incorrect responses"}) }}</span>
        </div>
        <div class="flex flex-row items-center gap-2">
          <span class="font-bold">{{
            getAnswerLabel(item.correctedItem.index)
          }}</span>
          <span v-html="item.text"></span>
        </div>
      </div>
    </div>
  </article>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "drag-drop-card-result",
  props: {
    answer: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getAnswerLabel(index: number) {
      return `${String.fromCharCode(65 + index)}:`;
    },
    restoreAnswerText(text: string) {
      this.answer.studentAnswers.forEach((answerStudent, indexAnswer) => {
        const answer: any = JSON.parse(answerStudent);
        const regex = new RegExp(`\\[resposta-hidden:${answer.id}\\]`, "g");
        const isCorrect =
          this.correctResponse[indexAnswer]?.name === answer.name;
        const className = isCorrect ? "correct-answer" : "incorrect-answer";
        text = text.replace(
          regex,
          `<span class="${className}">${answer.name}</span>`
        );
      });
      return text;
    },
  },
  computed: {
    processedItems(): any[] {
      return this.answer.question.items?.map((item) => ({
        ...item,
        answerText: this.restoreAnswerText(item.answerText),
      }));
    },

    correctResponse() {
      return this.answer.question.items.flatMap((item) =>
        item.correctOptions.map((option) => 
           JSON.parse(option)
        
        )
      );
    },
    
    correctedItems() {
      const correctedItemsList: any[] = [];
      this.answer.question.items?.forEach((item, indexItem) => {
        let correctAnswer = {
          text: item.answerText,
          correctedItem: { has: false, index: null },
        };

        this.answer.studentAnswers.forEach((answerStudent, indexAnswer) => {
          const answer: any = JSON.parse(answerStudent);
          const responseGap = `[resposta-hidden:${answer.id}]`;
         
          if (item.answerText.includes(responseGap)) {
         
            const regex = new RegExp(`\\[resposta-hidden:${answer.id}\\]`, "g");
            const correctName =
              this.correctResponse[indexAnswer]?.name;

            if (correctName === answer.name) {
              correctAnswer.text = correctAnswer.text.replace(
                regex,
                `<span class="correct-answer">${answer.name}</span>`
              );
            } else {
              correctAnswer.text = correctAnswer.text.replace(
                regex,
                `<span class="corrected-answer">${correctName}</span>`
              );

              correctAnswer.correctedItem.has = true;
              correctAnswer.correctedItem.index = indexItem;
            }
          }
        });

        if (correctAnswer.correctedItem.has) {
          correctedItemsList.push(correctAnswer);
        }
      });

      return correctedItemsList;
    },
  },
});
</script>
<style lang="scss">
.correct-answer {
  @apply border border-h-primary-300 px-4 py-2 text-h-info-700 rounded-md;
}
.incorrect-answer {
  @apply border border-h-error-200 px-4 py-2 text-h-error-400 rounded-md;
}
.corrected-answer {
  @apply border border-h-success-300 px-4 py-2 text-h-success-500 rounded-md;
}
.item-answer {
  @apply m-3;
}
</style>
